import {
  Cached,
  Mapper,
  VersionMapper,
  FirestoreEntity,
  getFirestoreEntityVersionFn,
  ChainedMapper,
} from '../@harmony';
import {
  AnyIndustryEntityVersion,
  Industry,
  IndustryEntity,
  IndustryEntityToIndustryMapper,
} from '.';

export abstract class IndustryCommonProvider {
  abstract provideIndustryEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyIndustryEntityVersion>,
    FirestoreEntity<IndustryEntity>
  >;
  abstract provideIndustryEntityToIndustryMapper(): Mapper<
    FirestoreEntity<AnyIndustryEntityVersion>,
    Industry
  >;
}

export class IndustryCommonDefaultProvider implements IndustryCommonProvider {
  @Cached()
  public provideIndustryEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyIndustryEntityVersion>,
    FirestoreEntity<IndustryEntity>
  > {
    return new VersionMapper(getFirestoreEntityVersionFn, []);
  }

  @Cached()
  public provideIndustryEntityToIndustryMapper(): Mapper<
    FirestoreEntity<AnyIndustryEntityVersion>,
    Industry
  > {
    return new ChainedMapper<
      [FirestoreEntity<AnyIndustryEntityVersion>, FirestoreEntity<IndustryEntity>, Industry]
    >([this.provideIndustryEntityVersionsMapper(), new IndustryEntityToIndustryMapper()]);
  }
}
